var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useEffect, useState } from 'react';
import { MarketSection, MyAssetsTab } from '../../app/router/config';
import { CurrencyContext } from '../../context/currency';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { TokenType } from '../../types/common';
import { MAX_POWER_VALUE, MIN_POWER_VALUE, getPowersToFilter } from '../../utils/card-powers';
import { getMintPassNameFromKey } from '../../utils/filters';
import { getImxOrders } from '../../utils/imx-orders';
import { metadataFactions, metadataSeasons } from '../../utils/products';
export function useAssetsOnSale(filters, section) {
    var _a = useContext(LoadingContext), imxLoading = _a.imxLoading, setImxLoading = _a.setImxLoading;
    var _b = useContext(UserContext), selectedWallet = _b.selectedWallet, fees = _b.fees;
    var _c = useContext(CurrencyContext), usdcAddress = _c.usdcAddress, imxClient = _c.imxClient, queue = _c.queue, parseCurrencyQuantity = _c.parseCurrencyQuantity;
    var _d = useState(null), orders = _d[0], setOrders = _d[1];
    var _e = useState(null), displayedOrders = _e[0], setDisplayedOrders = _e[1];
    var _f = useState({ cta: undefined, usdc: undefined }), cursors = _f[0], setCursors = _f[1];
    var _g = useState({ cta: -1, usdc: -1 }), remainings = _g[0], setRemainings = _g[1];
    var _h = useState(0), refreshCount = _h[0], setRefreshCount = _h[1];
    useEffect(function () {
        if (section === MarketSection.MINT_PASSES) {
            filters.actions.setTokenTypes([TokenType.MINT_PASS]);
        }
        else if (section === MarketSection.ARISE) {
            filters.actions.setTokenTypes([TokenType.ARISE_COIN]);
        }
    }, [section]);
    useEffect(function () {
        setOrders(null);
        setDisplayedOrders(null);
        getOrders({ refresh: true });
    }, [
        usdcAddress,
        imxClient,
        fees,
        filters.state.currencyTokens,
        filters.state.tokenTypes,
        filters.state.advancements,
        filters.state.collections,
        filters.state.sets,
        filters.state.factions,
        filters.state.elements,
        filters.state.rarities,
        filters.state.minPower,
        filters.state.maxPower,
        filters.state.grades,
        filters.state.foils,
        filters.state.ranks,
        filters.state.animationLevels,
        filters.state.cardTypes,
        filters.state.mintPassTypes,
        filters.state.numberings,
        filters.state.searchQuery.value,
        filters.state.orderBy,
        filters.state.direction,
        selectedWallet,
    ]);
    function getOrders(options) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedFilters, result, newRefreshCount, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!usdcAddress ||
                            !imxClient ||
                            imxLoading ||
                            !fees ||
                            !selectedWallet ||
                            filters.state.tab !== MyAssetsTab.ON_SALE)
                            return [2 /*return*/];
                        setImxLoading(true);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        parsedFilters = {
                            tokenType: filters.state.tokenTypes.length > 0 ? filters.state.tokenTypes : undefined,
                            season: filters.state.collections.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.collections.map(function (collection) { return metadataSeasons[collection - 1]; })
                                : undefined,
                            set: filters.state.sets.length > 0 ? filters.state.sets.map(function (set) { return set.toString(); }) : undefined,
                            faction: filters.state.factions.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.factions.map(function (faction) { return metadataFactions[faction]; })
                                : undefined,
                            advancement: filters.state.advancements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.advancements
                                : undefined,
                            element: filters.state.elements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.elements
                                : undefined,
                            grade: filters.state.grades.length > 0 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.grades
                                : undefined,
                            rarity: filters.state.rarities.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.rarities
                                : undefined,
                            power: filters.state.tokenTypes[0] === TokenType.CARD &&
                                (filters.state.minPower !== MIN_POWER_VALUE || filters.state.maxPower !== MAX_POWER_VALUE)
                                ? getPowersToFilter(filters.state.minPower, filters.state.maxPower)
                                : undefined,
                            rank: filters.state.ranks.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.ranks.map(function (rank) { return rank.toString(); })
                                : undefined,
                            foil: filters.state.foils.length === 1 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.foils.map(function (value) { return value === true; })
                                : undefined,
                            animationLevel: filters.state.animationLevels.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.animationLevels
                                : undefined,
                            cardType: filters.state.cardTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.cardTypes
                                : undefined,
                            name: filters.state.mintPassTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.MINT_PASS
                                ? getMintPassNameFromKey(filters.state.mintPassTypes)
                                : undefined,
                            numbering: filters.state.numberings.length > 0 ? filters.state.numberings.map(function (value) { return value.toString(); }) : undefined,
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, orders, filters.state.tokenTypes[0], filters.state.currencyTokens, parsedFilters, filters.state.orderBy, filters.state.direction, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { sellTokenName: filters.state.searchQuery.value, user: selectedWallet.address }))];
                    case 1:
                        result = _a.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setOrders(result.orders);
                        setDisplayedOrders(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        if (options === null || options === void 0 ? void 0 : options.refresh) {
                            container = window.document.getElementById('my-assets-on-sale-grid');
                            container === null || container === void 0 ? void 0 : container.scrollTo({ top: 0 });
                        }
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function loadMoreOrders() {
        getOrders({ refresh: false });
    }
    return {
        orders: displayedOrders,
        getOrders: getOrders,
        loadMoreOrders: loadMoreOrders,
    };
}
